import React, { FunctionComponent } from 'react';
import { FavoriteBtn } from '../../atoms/favoriteBtn';

type Props = {
  companyId: number;
  recruitmentId: number;
  isConnected: boolean;
  messageBoxId?: number | null;
  isStopped: boolean;
  isLoggedIn: boolean;
  isCompany: boolean;
  isScouted: boolean;
  isShowMag: boolean;
  hideTopEntryButton: boolean;
  handleRegisterModalOpen: () => void;
  handleClickEntry: () => void;
  isPreview: boolean;
  handlePreviewClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  companyId,
  recruitmentId,
  isConnected,
  messageBoxId,
  isStopped,
  isLoggedIn,
  isCompany,
  isScouted,
  isShowMag,
  hideTopEntryButton,
  handleRegisterModalOpen,
  handleClickEntry,
  isPreview,
  handlePreviewClick,
}) => {
  return (
    <aside
      className="l-single-sidebar l-single-sidebar--clear pc-none is-fixed recruitment-entry-button-bottom"
    >
      <div className="single-sidebar u-clear">

        <div
          className="single-sidebar-conversion single-sidebar-conversion-fixed single-sidebar-conversion-connect single-sidebar-conversion-flex noShadow"
          id="company_id"
          data-company_id={companyId}
        >

          {/* FavoriteBtn の表示（会社ユーザー or 募集終了 の時は表示しない） */}
          {!isCompany && !isStopped && (
            <FavoriteBtn
              recruitmentId={String(recruitmentId)}
              isShow={true}
              railsDataCategory="recruitmentcontent"
              isPreview={isPreview}
            />
          )}

          {/* メッセージを確認（既にエントリー済み） */}
          {isConnected && messageBoxId && (
            <a
              className="button button-join button-join--recruitment button-bm button-border__icon gtm-button-view-count"
              href={`/messages/${messageBoxId}`}
              data-event-name='button on screen'
              data-event="click"
              data-category="recruitmentcontent"
              data-value="logged_in_to_message"
            >
              <span className="material-symbols-outlined cdn-icon to-message">sms</span>
              メッセージを確認
            </a>
          )}

          {/* 募集終了 */}
          {!isConnected && isStopped && (
            <a className="button button-join button-bm button-not-allowed" href="javascript:void(0);">
              募集終了しました
            </a>
          )}

          {/* 未ログイン → ログイン導線 */}
          {!isConnected && !isStopped && !isLoggedIn && (
            <a
              className="button button-join button-bm gtm-entry-view-count"
              href="javascript:void(0);"
              onClick={handleRegisterModalOpen}
              data-event-name='entry on screen'
              data-event="click"
              data-category="recruitmentcontent"
              data-value="not_login_entry"
              data-state={isShowMag ? 'with_mag' : 'no_mag'}
              data-ab-test={hideTopEntryButton ? 'top_entry_button__hidden' : 'top_entry_button__shown'}
            >
              まずはエントリー
            </a>
          )}

          {/* ログイン済み → エントリーモーダル */}
          {!isConnected && !isStopped && isLoggedIn && (
            <a
              className="button button-join button-bm gtm-entry-view-count"
              href="javascript:void(0);"
              onClick={isPreview ? handlePreviewClick : handleClickEntry}
              data-event-name='entry on screen'
              data-event="click"
              data-category="recruitmentcontent"
              data-value={
                (!isCompany && isScouted)
                  ? 'logged_in_scout_entry'
                  : 'logged_in_entry'
              }
              data-state={isShowMag ? 'with_mag' : 'no_mag'}
              data-ab-test={hideTopEntryButton ? 'top_entry_button__hidden' : 'top_entry_button__shown'}
            >
              まずはエントリー
            </a>
          )}
        </div>

      </div>
    </aside>
  );
};
